import { parse, format } from 'date-fns/fp';

import * as types from './types';

export const parseStringToDate = parse(new Date(), 'yyyy-MM-dd');
export const parseDateToString = format('yyyy-MM-dd');
// export const formatCalendarDate = parse(new Date(), 'yyyy MMM');

export function addEmptySlots(slots: types.AvailableSlot[]): types.AvailableSlot[] {
  const newSlots: types.AvailableSlot[] = [];
  let lastPosition = -1;

  slots.forEach((slot) => {
    // Add empty slots between the last position and the current position
    for (let i = lastPosition + 1; i < slot.position; i++) {
      newSlots.push({ type: types.EDaySlotType.empty, position: i, data: null });
    }

    // Add the current slot
    newSlots.push(slot);
    lastPosition = slot.position;
  });

  return newSlots;
}

export const createPositionStorage = () => {
  let positionState: Array<[types.CalendarEvent, { index: number; dayNumber: number }]> = [];

  const getPosition = (dayNumber: number, calendarEvent: types.CalendarEvent): number => {
    const eventPosition = positionState.find(([{ id }]) => calendarEvent.id == id);

    if (eventPosition) return eventPosition[1].index;

    const positionStateFiltered = positionState.filter(([{ daysRange }]) => {
      const startDayNumber = daysRange.start;
      const endDayNumber = daysRange.end || startDayNumber;

      return endDayNumber >= dayNumber;
    });

    const positionStateFilteredIndexes = positionStateFiltered.map(([, { index }]) => index);

    if (positionStateFilteredIndexes.length <= 0) {
      positionState = [...positionState, [calendarEvent, { index: 0, dayNumber }]];
      return 0;
    }

    function getSmallestFreeNumber(arr: number[]): number {
      const sortedArr = arr.sort((a, b) => a - b);
      let smallestFreeNumber = 0;

      for (let i = 0; i < sortedArr.length; i++) {
        if (sortedArr[i] > smallestFreeNumber) {
          return smallestFreeNumber;
        }
        smallestFreeNumber++;
      }

      return sortedArr[sortedArr.length - 1] + 1;
    }

    const index = getSmallestFreeNumber(positionStateFilteredIndexes);

    positionState = [...positionState, [calendarEvent, { index, dayNumber }]];
    return index;
  };

  return { getPosition };
};

export const checkIsEventInitialInPeriod = (
  event: types.CalendarEvent,
  options: {
    calendarDay: Pick<types.TCalendarDay, 'dayNumber'>;
    period: types.Period;
  },
) => {
  const { calendarDay, period } = options;

  const startDayNumber = event.daysRange.start;
  const endDayNumber = event.daysRange.end || startDayNumber;

  if (startDayNumber === endDayNumber) return true;
  if (calendarDay.dayNumber === startDayNumber) return true;

  if (period[0].dayNumber === calendarDay.dayNumber) return true;

  return false;
};
